module.exports = __webpack_public_path__ + "img/maestro.469ab462.svg";